import { render, staticRenderFns } from "./EditReportPeople.vue?vue&type=template&id=c6bdad0c&"
import script from "./EditReportPeople.vue?vue&type=script&lang=js&"
export * from "./EditReportPeople.vue?vue&type=script&lang=js&"
import style0 from "./EditReportPeople.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports